export const Landing2PageTemplate = {
    slots: ['SlbProductListPageContainerSlot', 'SlbBlueBottomBannerSlot'],
};

